import { render, staticRenderFns } from "./USDIRBitableReport.vue?vue&type=template&id=75a66e32&scoped=true&"
import script from "./USDIRBitableReport.vue?vue&type=script&lang=ts&"
export * from "./USDIRBitableReport.vue?vue&type=script&lang=ts&"
import style0 from "./USDIRBitableReport.vue?vue&type=style&index=0&id=75a66e32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a66e32",
  null
  
)

export default component.exports